import axios from 'axios'
import { withActingStoreHeader } from '../utils/actingStore'

const axiosInstance = axios.create()

// Request interceptor
axiosInstance.interceptors.request.use(
	(config) => {
		const currentUser = JSON.parse(localStorage.getItem('current-user'))
		const token = currentUser?.accessToken

		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`
		}
		return withActingStoreHeader(config)
	},
	(error) => {
		return Promise.reject(error)
	},
)

// Response interceptor
axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		return Promise.reject(error)
	},
)

// Base API methods
export const apiBase = {
	get: async (url, params = {}) => {
		try {
			const response = await axiosInstance.get(url, { params })
			return response.data
		} catch (error) {
			throw error
		}
	},

	post: async (url, data = {}) => {
		try {
			const response = await axiosInstance.post(url, data)
			return response.data
		} catch (error) {
			throw error
		}
	},

	put: async (url, data = {}) => {
		try {
			const response = await axiosInstance.put(url, data)
			return response.data
		} catch (error) {
			throw error
		}
	},

	delete: async (url, data = {}) => {
		try {
			const response = await axiosInstance.delete(url, { data })
			return response.data
		} catch (error) {
			throw error
		}
	},

	patch: async (url, data = {}) => {
		try {
			const response = await axiosInstance.patch(url, data)
			return response.data
		} catch (error) {
			throw error
		}
	},
}

export default axiosInstance
